import { App as AntApp } from "antd";
import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import AppShell from "./components/AppShell";
import { WebSocketProvider } from "./contexts/WebSocketContext";
import Backtest from "./pages/Backtest";
import Landing from "./pages/Landing";
import Logs from "./pages/Logs";
import Portfolio from "./pages/Portfolio";
import Results from "./pages/Results";
import Settings from "./pages/Settings";
import { ThemeProvider } from "./theme/ThemeContext";

export default function App() {
  return (
    <ThemeProvider>
      <AntApp>
        <WebSocketProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/app" element={<AppShell />}>
                <Route index element={<Results />} />
                <Route path="portfolio" element={<Portfolio />} />
                <Route path="backtest" element={<Backtest />} />
                <Route path="logs" element={<Logs />} />
                <Route path="settings" element={<Settings />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </WebSocketProvider>
      </AntApp>
    </ThemeProvider>
  );
}
